import {general as textsGeneral, itemBag as textsItemBag} from '../../../translate/Translate.jsx'
import './observations.scss'
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded'
import {getSession} from '../../../hooks/useStorage/useStorage.jsx'

const Observations = ({onClick}) => {
    const observation = getSession('observation') || ''
    return <div className={'observation'}>
        <div className={'div-observation'}>
            <div className={'div-descriptions'}>
                <EditNoteRoundedIcon className={'icon'}/>
                <div className={'descriptions'}>
                    <label className={'title'}>
                        {textsGeneral.observationDelivery}
                    </label>
                    <label className={'description'}>
                        {observation}
                    </label>
                </div>
            </div>
            <div className={'button'} onClick={() => onClick('observation')}>
                <label className={'label'}>
                    {textsItemBag.toAlter}
                </label>
            </div>
        </div>
    </div>
}

export default Observations
